import React from 'react'
import times from 'lodash/times'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material'
import { Checkbox, Dropdown, TextField } from '@carsys/form'
import { useGetProductTree } from '../hooks/useGetProductTree'

const Data: React.FC = () => {
  const { t } = useTranslation()
  const { tree_uuid } = useParams<{ tree_uuid: string }>()
  const { data: productGroup } = useGetProductTree(tree_uuid)
  const numberOfCategories = productGroup?.Categories.length || 0

  const options = times(numberOfCategories, index => ({
    key: index,
    text: index.toString(),
    value: index
  }))

  return (
    <Card variant='outlined'>
      <CardHeader title={<Typography variant='h6'>{t('productgroup.tree_maingroup_title')}</Typography>} />
      <Divider />
      <CardContent>
        <TextField fullWidth variant='outlined' label={t('productgroup.name')} name='Name' required sx={{ mb: 2 }} />
        <Dropdown required label={t('productgroup.order')} fullWidth name='SortOrder' options={options} />
        <Checkbox name='IsActive' label={t('productgroup.is_active')} />
      </CardContent>
    </Card>
  )
}

export default Data
